module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title"
  }, [_vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("He was born in Ireland in the early thirties, a big foal even longer-legged than usual, legs that were slender but strong, already showing incipient power. His eyes, as with all foals, looked over-large in his narrow fine-boned face; his nostrils were large too. At birth he was black with the usual lighter ridge of mane and pampas flock of tail. His dam was Black Tulip, he was sired by Bold Crusader and so was registered as Dark Invader but, for two days of his life, he was to be known as Beauty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As a yearling, Dark Invader was seen and bought by the rich and spoiled young owner, Captain the Honourable Peter Hay, on the advice of his trainer Michael Traherne. It was a hefty price, but it was a well-bred colt and, ‘Having come to Dublin, Peter was going to buy something anyhow,’ Michael told his wife, Annette, ‘and this seemed a likely one.’")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The big youngster was shipped to the Traherne stables at Dilbury on the Berkshire downs where, lucky horse, he came under the care of that gnome of a stable lad, Ted Mullins. At the end of their career it was difficult to think of one without the other.")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abd8731a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Prologue.vue
// module id = 69
// module chunks = 0